export var isToolbar = function isToolbar(component) {
  return (component === null || component === void 0 ? void 0 : component.type) === 'toolbar';
};